export enum SalesType {
  Simple = 'SIMPLE',
  Composite = 'COMPOSITE',
}
